import { getSectionProps } from '@/utils/styles';
import RichTextHeadline from '@/components/shared/RichTextHeadline/RichTextHeadline';
import Media from '@/components/shared/Media/Media';
import { HeadlineWithEyebrowProps } from '@/libs/contentful/props';
import { Colorways } from '@/types/constants';

const HeadlineWithEyebrow = ({ headline, eyebrowLogo, color, sectionName, margins }: HeadlineWithEyebrowProps) => {
  return (
    <section {...getSectionProps(color ?? Colorways.Primary, margins, sectionName)}>
      <div className={'content-wrapper flex flex-col items-center w-full'}>
        {eyebrowLogo && (
          <Media
            media={eyebrowLogo}
            sizes={'(max-width: 750px) 76px, 82px'}
            className={'h-15.5 sm:h-16.5 object-contain -mb-3 sm:-mb-4'}
          />
        )}
        <div className={'font-sans text-heading-md sm:text-heading-lg text-center'}>
          <RichTextHeadline headline={headline} />
        </div>
      </div>
    </section>
  );
};

export default HeadlineWithEyebrow;
